var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarSharpHalf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M270.719 12.566L215.83 181.641H38.225C20.608 181.641 13.279 204.182 27.527 214.543L171.227 319.035L116.338 488.109C112.196 500.873 122.327 512 133.684 512C137.237 512 140.911 510.91 144.303 508.443L274.822 413.535C283.103 407.514 288.002 397.893 288.002 387.654V15.761C288.002 5.991 273.937 3.063 270.802 12.316C270.774 12.399 270.746 12.483 270.719 12.566ZM218.248 293.879L129.907 229.641H240.002V379.506L190.338 415.621L224.055 311.76C226.196 305.17 223.85 297.953 218.248 293.879Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarSharpHalf);
export default __webpack_public_path__ + "static/media/star-sharp-half.0a9dcf26ddb00b9f675e2685b5c69d14.svg";
export { ForwardRef as ReactComponent };